<template>
    <div class="d-flex flex-column bg-light">
        <Header />
        <div class="row">
            <label>
                <span style="margin-left: 15px;">
                    Status:
                    <span style="padding-left: 10px; font-weight: normal;">{{ CalendarStatus }}</span>
                    <span style="padding-left: 10px; padding-right: 10px">|</span>
                    Calendar Type:
                    <span style="font-weight: normal; padding-left: 10px;">{{ CalendarType }}</span>
                    <span style="padding-left: 10px; padding-right: 10px">|</span> School
                    Year:
                    <span style="font-weight: normal; padding-left: 10px;">{{ SchoolYear }}</span>
                    <span style="padding-left: 10px; padding-right: 10px">|</span>
                    Program Entity Id:
                    <span style="font-weight: normal; padding-left: 10px">
                        {{
                    progEntityId
                        }}
                    </span>
                    <span style="padding-left: 10px; padding-right: 10px">|</span>
                    Program:
                    <span style="font-weight: normal; padding-left: 10px">
                        {{
                    ProgramName
                        }}
                    </span>
                </span>
            </label>
        </div>
        <div class="row">
            <div class="col-md-10"></div>
            <div class="col-md-2 text-right noprint" style="padding:0px 24px 0px 0px;">
                <p class="pull-right">
                    <button @click="print" class="btn raised " style="background-color: #013e5a!important;color:white"><i class="fas fa-print"></i> &nbsp;Print Calendar</button>
                </p>
            </div>
        </div>
        <div class="row body-margin-print-top"></div>
        <div id="formCalendarView">
            &nbsp;
            <div class="row calendars" x-style="text-align:left">
                <div class="col-12 col-sm-6 col-md-4 col-xl-3 mx-auto col-print-3"
                     x-style="font-size: 5pt; x-width: 200px"
                     v-for="month in calendarMonths"
                     :key="month?.display">
                    <div :id="month?.display"></div>
                    <font><b>{{ month?.month }} Atnd:&nbsp;</b></font>
                    <label style="font-weight: normal">
                        {{
            dayCountsLookup[month?.display]
                        }}
                    </label>
                </div>
            </div>
        </div>
        <div class="row body-margin-less-top">
            <div class="col-md-6">
                <label>
                    <span style="font-size: 15px">Calendar Legend - Total Number of Days</span>
                </label>


                <CalendarLegend />
            </div>
        </div>
        <br />
        <br />

        <div class="form-group row">
            <label class="col-sm-2 col-form-label font-weight-bold">
                Regular School Year Begins:
            </label>
            <div class="col-sm-2">
                <span id="RegularBeginDate" class="form-control-plaintext" />
            </div>
            <label class="col-sm-2 col-form-label font-weight-bold">
                Regular School Year Closes:
            </label>
            <div class="col-sm-2">
                <span id="RegularEndDate" class="form-control-plaintext" />
            </div>
        </div>

        <div class="form-group row" id="SummerDates">
            <label class="col-sm-2 col-form-label font-weight-bold">
                Summer School Session Begins:
            </label>
            <div class="col-sm-2">
                <span id="SummerBeginDate" class="form-control-plaintext" />
            </div>
            <label class="col-sm-2 col-form-label font-weight-bold">
                Summer School Session Closes:
            </label>
            <div class="col-sm-2">
                <span id="SummerEndDate" class="form-control-plaintext" />
            </div>
        </div>

        <div class="form-group row" id="TotalDates">
            <label class="col-sm-2 col-form-label font-weight-bold">
                Total Regular Days:
            </label>
            <div class="col-sm-2">
                <span id="TotalRegularDays" class="form-control-plaintext" />
            </div>
            <label class="col-sm-2 col-form-label font-weight-bold">
                Total Summer Hours:
            </label>
            <div class="col-sm-2">
                <span id="TotalSummerHours" class="form-control-plaintext" />
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Header from "../components/Header.vue";
    import Footer from "../components/Footer.vue";
    import $ from "jquery";
    import moment from "moment";
    import Constants from "../utilities/Constants.js";
    import "bootstrap/dist/css/bootstrap.min.css";
    import "jquery/dist/jquery.min.js";
    import "datatables.net-dt/js/dataTables.dataTables";
    import "datatables.net-dt/css/jquery.dataTables.min.css";
    import CalendarLegend from "../components/CalendarLegend";
    import axios from "axios";

    /* eslint-disable */
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    function monthNumToName(monthnum) {
        return months[monthnum - 1] || "";
    }
    function monthNameToNum(monthname) {
        const month = months.indexOf(monthname);
        return month ? month + 1 : 0;
    }

    export default {
        components: {
            //Fullcalendar,
            Header,
            Footer,
            CalendarLegend,
        },

        data() {
            return {
                dayCountsLookup: {},
                CalendarStatus: "",
                CalendarType: "",
                SchoolYear: "",
                ProgramName: "",
                ProgramEntityId: "",
                // RegularHours: "",
                // SummerHours: "",
                IsHalfDayBilledAsFullDayFlag: false,
                calendarOptions: {
                    initialView: "dayGridMonth",
                    //initialDate: this.$route.params.year - 1 + "-08-01",
                    weekends: false,
                    height: 460,
                    events: [],
                    headerToolbar: { right: "", center: "title", left: "" },
                    showNonCurrentDates: false,
                },
                calendarMonths: null,
                printInProgress: false,
            };
        },

        mounted() {
            const schoolYear = this.$route.params.year;
            const progEntityId = this.$route.params.id;
            let WebURL = "";

            WebURL = `${Constants.API_URL}/api/PFSearchApi/GetLatestCalendarMainId`;
            let parameters = `schoolYear=${schoolYear}&progEntityId=${progEntityId}`;
            const latestCalendarResponse = `${WebURL}?${parameters}`;

            fetch(latestCalendarResponse)
                .then((response) => response.json())
                .then((data) => {
                    this.latestCalendarMainId = data[0].CalendarMainId;
                    if (this.latestCalendarMainId > 0) {
                        WebURL = `${Constants.API_URL}/api/PFSearchApi/GetCalendarEvents`;
                        parameters = `calendarMainId=${this.latestCalendarMainId}`;
                        const calendarEventsResponse = `${WebURL}?${parameters}`;
                        let vue = this;
                        fetch(calendarEventsResponse)
                            .then((response) => response.json())
                            .then((data) => {
                                this.CalendarStatus = data[0].CalendarStatus;
                                this.CalendarType = data[0].CalendarType;
                                this.SchoolYear = data[0].SchoolYear;
                                this.ProgramName = data[0].ProgramName;
                                this.progEntityId = this.$route.params.id
                                this.ProgramEntityId = this.$route.params.id
                                const events = data.map((v) => ({
                                    title: v.CalendarAttendanceType,
                                    start: moment(String(v.CalendarDate)).format("YYYY-MM-DD"),
                                    end: moment(String(v.CalendarDate)).format("YYYY-MM-DD"),
                                    color: v.ThemeColor,
                                }));
                                this.calendarMonths.forEach((month) => {
                                    const currentMonth = document.getElementById(month.display);
                                    const instance = new window.FullCalendar.Calendar(
                                        currentMonth,
                                        {
                                            ...vue.calendarOptions,
                                            initialDate: month.display,
                                            events,
                                        }
                                    );
                                    instance.render();
                                });
                            });
                    }

                    WebURL = `${Constants.API_URL}/api/PFSearchApi/GetCountsByMonth`;
                    parameters = `calendarMainId=${this.latestCalendarMainId}`;
                    const calendarCountsResponse = `${WebURL}?${parameters}`;

                    fetch(calendarCountsResponse)
                        .then((response) => response.json())
                        .then((data) => {
                            this.dayCountsLookup = this.calendarMonths.reduce((res, next) => {
                                const [, year, month] = /(\d{4})-(\d{2})-\d{2}/.exec(
                                    next.display
                                );

                                const matchingDayCountEntry = data.find(
                                    (entry) =>
                                        entry.CalendarYear === Number(year) &&
                                        entry.CalendarMonth.startsWith(monthNumToName(Number(month)))
                                );

                                return {
                                    ...res,
                                    [next.display]:
                                        matchingDayCountEntry && matchingDayCountEntry.DayCount,
                                };
                            }, {});
                        });

                    let RegularHoursPerDay = 0;
                    let SummerHoursPerDay = 0;
                    WebURL = `${Constants.API_URL}/api/PFSearchApi/GetBeginAndEndDates`;
                    parameters = `calendarMainId=${this.latestCalendarMainId}`;
                    const calendarDatesResponse = `${WebURL}?${parameters}`;
                    fetch(calendarDatesResponse)
                        .then((response) => response.json())
                        .then((data) => {
                            $.each(data, function (i, v) {
                                RegularHoursPerDay = v.RegularHoursPerDay;
                                SummerHoursPerDay = v.SummerHoursPerDay;
                                console.log(RegularHoursPerDay);
                                console.log(SummerHoursPerDay);

                                if (
                                    v.RegularBeginDate !== undefined &&
                                    v.RegularBeginDate !== null
                                ) {
                                    $("#RegularBeginDate").text(
                                        moment(String(v.RegularBeginDate)).format("YYYY-MM-DD")
                                    );
                                }
                                if (v.RegularEndDate !== undefined && v.RegularEndDate !== null) {
                                    $("#RegularEndDate").text(
                                        moment(String(v.RegularEndDate)).format("YYYY-MM-DD")
                                    );
                                }
                                if (
                                    v.SummerBeginDate !== undefined &&
                                    v.SummerBeginDate !== null
                                ) {
                                    $("#SummerBeginDate").text(
                                        moment(String(v.SummerBeginDate)).format("YYYY-MM-DD")
                                    );
                                    $("#SummerDates").show();
                                    $("#SummerHours").show();
                                }
                                if (v.SummerEndDate !== undefined && v.SummerEndDate !== null) {
                                    $("#SummerEndDate").text(
                                        moment(String(v.SummerEndDate)).format("YYYY-MM-DD")
                                    );
                                    $("#SummerDates").show();
                                    $("#SummerHours").show();
                                }
                                if (
                                    v.ApprovedRegularBeginDate !== undefined &&
                                    v.ApprovedRegularBeginDate !== null
                                ) {
                                    $("#ApprovedRegularBeginDate").text(
                                        moment(String(v.ApprovedRegularBeginDate)).format(
                                            "YYYY-MM-DD"
                                        )
                                    );
                                }
                                if (
                                    v.ApprovedRegularEndDate !== undefined &&
                                    v.ApprovedRegularEndDate !== null
                                ) {
                                    $("#ApprovedRegularEndDate").text(
                                        moment(String(v.ApprovedRegularEndDate)).format("YYYY-MM-DD")
                                    );
                                }
                                if (
                                    v.ApprovedSummerBeginDate !== undefined &&
                                    v.ApprovedSummerBeginDate !== null
                                ) {
                                    $("#ApprovedSummerBeginDate").text(
                                        moment(String(v.ApprovedSummerBeginDate)).format("YYYY-MM-DD")
                                    );
                                    $("#ApprovedSummerDates").show();
                                    $("#SummerHours").show();
                                }
                                if (
                                    v.ApprovedSummerEndDate !== undefined &&
                                    v.ApprovedSummerEndDate !== null
                                ) {
                                    $("#ApprovedSummerEndDate").text(
                                        moment(String(v.ApprovedSummerEndDate)).format("YYYY-MM-DD")
                                    );
                                    $("#ApprovedSummerDates").show();
                                    $("#SummerHours").show();
                                }
                            });

                            this.CheckIfHalfDayBilledAsFullDay();
                            WebURL = `${Constants.API_URL}/api/PFSearchApi/GetCalendarTotals`;
                            parameters = `calendarMainId=${this.latestCalendarMainId}`;
                            const calendarTotalsResponse = `${WebURL}?${parameters}`;
                            let XAttendance = 0;
                            let HalfXAttendance = 0;
                            let SAttendance = 0;
                            fetch(calendarTotalsResponse)
                                .then((response) => response.json())
                                .then((data) => {

                                    $.each(data, function (i, v) {
                                        if (v.Attendance !== undefined &&
                                            v.Attendance == "TotalRegularFullAttendance") {
                                            XAttendance = v.DayCount;
                                        } else if (v.Attendance !== undefined &&
                                            v.Attendance == "TotalRegularHalfAttendance") {
                                            HalfXAttendance = v.DayCount;
                                        } else if (v.Attendance !== undefined &&
                                            v.Attendance == "SummerRegularAttendance") {
                                            SAttendance = v.DayCount;
                                        }
                                    });

                                    if (HalfXAttendance != undefined && HalfXAttendance > 0) {
                                        $("#HalfDayAsFullDay").show();
                                        if (this.IsHalfDayBilledAsFullDayFlag == false || this.IsHalfDayBilledAsFullDayFlag == "false") {
                                            $("#TotalRegularDays").text(
                                                XAttendance +
                                                HalfXAttendance / 2 +
                                                " days (" +
                                                RegularHoursPerDay +
                                                " hours per day)");
                                        }
                                        else {
                                            $("#TotalRegularDays").text((XAttendance + HalfXAttendance) + ' days (' + RegularHoursPerDay + ' hours per day)');
                                        }
                                    } else if (XAttendance != undefined && XAttendance > 0) {
                                        $("#TotalRegularDays").text(
                                            XAttendance +
                                            " days (" +
                                            RegularHoursPerDay +
                                            " hours per day)");
                                    }

                                    if (SAttendance != undefined && SAttendance > 0) {
                                        $("#TotalSummerHours").text(
                                            SAttendance +
                                            " * " +
                                            SummerHoursPerDay +
                                            " = " +
                                            parseFloat(SAttendance * SummerHoursPerDay).toFixed(
                                                2
                                            ) +
                                            " hours");
                                    }
                                });
                        });
                });
        },
        methods: {
            print() {
                let element = document.getElementById("calendarPrintPage");
                window.print();
            },
            CheckIfHalfDayBilledAsFullDay() {
                let WebURL = `${Constants.API_URL}/api/PFSearchApi/GetIsHalfDayBilledAsFullDayFlag?calendarMainId=${this.latestCalendarMainId}`;
                axios.get(WebURL)
                    .then(resp => (this.IsHalfDayBilledAsFullDayFlag = resp.data.data));
            }
        },
        created() {
            const schoolYear = this.$route.params.year;
            this.calendarMonths = [];
            const startMonth = 8;
            for (let i = 0; i <= 12; i++) {
                const currentMonth =
                    startMonth + i <= 12 ? startMonth + i : startMonth + i - 12;
                const displayMonth = (currentMonth + "").padStart(2, "0");
                if (startMonth + i <= 12) {
                    this.calendarMonths.push({
                        display: `${schoolYear - 1}-${displayMonth}-01`,
                        month: monthNumToName(currentMonth),
                    });
                } else {
                    this.calendarMonths.push({
                        display: `${schoolYear}-${displayMonth}-01`,
                        month: monthNumToName(currentMonth),
                    });
                }
            }
        },
    };
</script>
